import {OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {Observable} from "rxjs";
import moment from "moment/moment";

@Pipe({
    name: 'durationToNow',
})
export class DurationToNowPipe implements PipeTransform, OnDestroy {
    timer: any;

    transform(startDate: string): Observable<string> {
        if (startDate) {
            return new Observable(observer => {
                observer.next(this.durationCalc(startDate));
                this.timer = setInterval(() => {
                    observer.next(this.durationCalc(startDate));
                }, 1000);
            });
        }
    }

    durationCalc(start: string): string {
        const startDate = moment(start);
        const endDate = moment();

        // Calculate the total number of days, hours, minutes, and seconds
        const totalDays = endDate.diff(startDate, 'days');
        const totalHours = endDate.diff(startDate, 'hours') % 24;
        const totalMinutes = endDate.diff(startDate, 'minutes') % 60;
        const totalSeconds = endDate.diff(startDate, 'seconds') % 60;

        let duration = '';

        if (totalDays > 0) {
            duration += totalDays + ' days, ';
        }
        if (totalHours > 0 || duration) {
            duration += totalHours + ' h, ';
        }
        if (totalMinutes > 0 || duration) {
            duration += totalMinutes + ' min, ';
        }
        if (totalSeconds > 0 || duration) {
            duration += totalSeconds + ' sec';
        }

        if (duration.endsWith(', ')) {
            duration = duration.slice(0, -2);
        }

        return duration;
    }

    ngOnDestroy() {
        clearInterval(this.timer);
    }

}
